import { useLocation } from './useLocation';

export function useAllQueryParamValues(
	name: string,
): string | string[] | undefined {
	const { query } = useLocation();

	return query[name];
}
